import 'utility/config';
import React, { Suspense } from 'react';
import { RouterProvider } from '@tanstack/react-router';

import './style/custom.css'
import { useIdleTimer } from 'react-idle-timer';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import {
    User
} from 'model';
import {
    selectUserAuthenticated,
    logout,
    selectUser,
    setRedirect,
    selectRedirect,
    getUser
} from 'store/user';
import {
    heartbeat,
    init,
    selectInitialized,
} from 'store/messenger';
import { message } from 'antd';

import { router } from './routes/routeTree';

import Login from 'components/login/Login';

const App = () => {
    const dispatch = useAppDispatch();
    const userAuthenticated: boolean = useAppSelector(selectUserAuthenticated);
    const initialized: boolean = useAppSelector(selectInitialized);
    const user: User | null = useAppSelector(selectUser);

    const redirect: boolean = useAppSelector(selectRedirect);

    React.useEffect(() => {
        if (user == null) {
            dispatch(getUser());
        }
        const timer = setInterval(() => {
            dispatch(heartbeat());
        }, 30000);
        return () => clearInterval(timer);
    }, []);


    message.config({
        duration: 3,
        maxCount: 1
    });

    const handleOnIdle = () => {
        if (globalThis.twilioRoom != undefined) {
            window.dispatchEvent(new Event('disconnectFromRoom'));
        }
        setTimeout(() => {
            dispatch(logout());
        }, 1000);
    }

    const handleOnActive = (event) => {
        //console.log('user is active', event)
    }

    const handleOnAction = (e) => {
        //console.log('user did something', e)
    }

    //3600000 = 1 hour
    //43200000 = 12 hours
    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: 43200000,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500
    });

    React.useEffect(() => {
        if (userAuthenticated) {
            if (!initialized) {
                dispatch(init());
            }
        }
        if (userAuthenticated && redirect && user && user.page && user.page.length > 0) {
            dispatch(setRedirect());
            let pageToNavigate = user.page;
            //make sure to page starts with /
            if (!pageToNavigate.startsWith('/')) {
                pageToNavigate = `/${pageToNavigate}`;
            }
            // console.log("Navigating to:", user.page);
            // Navigate to user.page using router
            router.navigate({ to: pageToNavigate as any });
        }
    }, [userAuthenticated, redirect, user]);

    if (userAuthenticated) {
        return <RouterProvider router={router} />;
    } else {
        return <Login />;
    }
};

export default App;
